import { createTheme } from "@mui/material";

const DevelopTheme = createTheme({
  palette: {
    primary: {
      main: "#d3ecf5",
      contrastText: "#254854",
    },
    toolButton: {
      main: "#e1f0e3",
      contrastText: "#1d5225",
    },
    toolButtonActive: {
      main: "#116135",
      contrastText: "#d1e8db",
    },
    toolButtonDisabled: {
      main: "#f2f5f3",
      contrastText: "#d3dbd4",
    },
    cancelButton: {
      main: "#8699a6",
      contrastText: "#edf3f7",
    },
    blueButton: {
      main: "#2793db",
      contrastText: "#e1ebf2",
    },
    redButton: {
      main: "#d43939",
      contrastText: "#f5e1e1",
    },
    blackButton: {
      main: "#000000",
      contrastText: "#ffffff",
    },
    contextMenuButton: {
      main: "#fcfcfc",
      contrastText: "#262626",
    },
    contextMenuButtonDisabled: {
      main: "#d9d9d9",
      contrastText: "#adadad",
    },
    coachingPointAssetUploadButton: {
      main: "#afc6dd",
      contrastText: "#394e66",
    },
  },
  secondary: {
    main: "#4d74f5",
  },

  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
});

export default DevelopTheme;
